<template>
<v-chip >
  <v-avatar left color='teal white--text' >
    <v-img v-if='profilePicture' :src='profilePicture' />
    <span v-else >{{ initials }}</span>
  </v-avatar>
  {{fullname}}
</v-chip>
</template>
<script>
export default {
  name: 'PractitionerChip',
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    fullname () {
      let p = this.item
      if (p) {
        if (p.full_name) { return p.full_name }
        if (p.user && p.user.id) {
          return `${p.user.first_name} ${p.user.last_name}`
        }
        if (p.first_name) {
          return `${p.first_name} ${p.last_name}`
        }
      }
      return ''
    },
    profilePicture () {
      if (this.item) {
        if (this.item.profile_picture) { return this.item.profile_picture }
        if (this.item.profile && this.item.profile.profile_picture) {
          return this.item.profile.profile_picture
        }
      }
      return null
    },
    initials () {
      if (this.fullname) {
        let items = this.fullname.split(' ')
        if (items && items.length > 0) {
          return items.slice(0, 1).map((word) => { return word[0] }).join('')
        }
      }
      return null
    }
  }
}
</script>
